import { useDispatch } from "react-redux";
import { viewIcon } from "../../assets/icons";
import { MODALS } from "../organisms/AppModals/modals.constants";
import { actions as modalActions } from "../organisms/Modal/modal.reducers";

const JsonRenderer = (props, field) => {
  const dispatch = useDispatch();
  const { setSelectedModal } = modalActions;
  const { VIEW_JSON_MODAL } = MODALS;

  return (
    <div className="group flex h-full  m-auto items-center">
      <img
        src={viewIcon}
        alt="alert-icon"
        className="absolute top-3  group-hover:block w-4 h-4 "
        onClick={() => dispatch(setSelectedModal(VIEW_JSON_MODAL))}
      />
    </div>
  );
};

export default JsonRenderer;
